import { useTranslation } from "react-i18next";
import "./StatsNumbers.css";

interface IStatsNumbers {
  page: string;
}

export function StatsNumbers({ page }: IStatsNumbers) {
  const { t } = useTranslation();

  const statsData =
    page === "main"
      ? [
          {
            title: t("statsnumbers1_title"),
            subtitle: t("statsnumbers1_subtitle"),
          },
          {
            title: t("statsnumbers2_title"),
            subtitle: t("statsnumbers2_subtitle"),
          },
        ]
      : page === "chicken"
      ? [
          {
            title: t("statsnumbersgames1_title"),
            subtitle: t("statsnumbersgames1_subtitle"),
          },
          {
            title: t("statsnumberschicken2_title"),
            subtitle: t("statsnumberschicken2_subtitle"),
          },
          {
            title: t("statsnumbersgames3_title"),
            subtitle: t("statsnumbersgames3_subtitle"),
          },
          {
            title: t("statsnumberschicken4_title"),
            subtitle: t("statsnumberschicken4_subtitle"),
          },
        ]
      : page === "mines"
      ? [
          {
            title: t("statsnumbersgames1_title"),
            subtitle: t("statsnumbersgames1_subtitle"),
          },
          {
            title: t("statsnumbersmines2_title"),
            subtitle: t("statsnumbersmines2_subtitle"),
          },
          {
            title: t("statsnumbersgames3_title"),
            subtitle: t("statsnumbersgames3_subtitle"),
          },
          {
            title: t("statsnumbersmines4_title"),
            subtitle: t("statsnumbersmines4_subtitle"),
          },
        ]
      : page === "towers"
      ? [
          {
            title: t("statsnumbersgames1_title"),
            subtitle: t("statsnumbersgames1_subtitle"),
          },
          {
            title: t("statsnumberstowers2_title"),
            subtitle: t("statsnumberstowers2_subtitle"),
          },
          {
            title: t("statsnumbersgames3_title"),
            subtitle: t("statsnumbersgames3_subtitle"),
          },
          {
            title: t("statsnumberstowers4_title"),
            subtitle: t("statsnumberstowers4_subtitle"),
          },
        ]
      : page === "plinko"
      ? [
          {
            title: t("statsnumbersgames1_title"),
            subtitle: t("statsnumbersgames1_subtitle"),
          },
          {
            title: t("statsnumbersplinko2_title"),
            subtitle: t("statsnumbersplinko2_subtitle"),
          },
          {
            title: t("statsnumbersgames3_title"),
            subtitle: t("statsnumbersgames3_subtitle"),
          },
          {
            title: t("statsnumbersplinko4_title"),
            subtitle: t("statsnumbersplinko4_subtitle"),
          },
        ]
      : page === "dice"
      ? [
          {
            title: t("statsnumbersgames1_title"),
            subtitle: t("statsnumbersgames1_subtitle"),
          },
          {
            title: t("statsnumbersdice2_title"),
            subtitle: t("statsnumbersdice2_subtitle"),
          },
          {
            title: t("statsnumbersgames3_title"),
            subtitle: t("statsnumbersgames3_subtitle"),
          },
          {
            title: t("statsnumbersdice4_title"),
            subtitle: t("statsnumbersdice4_subtitle"),
          },
        ]
      : page === "crash"
      ? [
          {
            title: t("statsnumbersgames1_title"),
            subtitle: t("statsnumbersgames1_subtitle"),
          },
          {
            title: t("statsnumberscrash2_title"),
            subtitle: t("statsnumberscrash2_subtitle"),
          },
          {
            title: t("statsnumbersgames3_title"),
            subtitle: t("statsnumbersgames3_subtitle"),
          },
          {
            title: t("statsnumberscrash4_title"),
            subtitle: t("statsnumberscrash4_subtitle"),
          },
        ]
      : [];
  return (
    <div className="stats-numbers">
      {statsData.map((obj, index) => (
        <div key={index} className="stats-numbers-container">
          <h4 className="stats-numbers-title">{obj.title}</h4>
          <p className="stats-numbers-description">{obj.subtitle}</p>
        </div>
      ))}
    </div>
  );
}
